import React from "react";
import StackedLayout from "./Layouts/Stacked";
import TwoColumnLayout from "./Layouts/TwoColumn";
import OverlayedLayout from "./Layouts/Overlayed";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import "./PageHeader.scss";

const layouts = {
    "stacked": StackedLayout,
    "2column": TwoColumnLayout,
    "overlayed": OverlayedLayout,
};

export const PageHeader = ({ settings, blocks }) => {
    const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);
    let Layout = layouts[settings.section.layout_type] || StackedLayout;

    let sortedBlocks = blocks;

    if (blocks) {
        if (isMobile) {
            // Sort blocks based on the sort_order setting
            sortedBlocks = [...blocks].sort(
                (a, b) => a.settings.sort_order_mobile - b.settings.sort_order_mobile,
            );
        }
    }

    if (isMobile) {
        Layout = layouts[settings.section.layout_type_mobile] || StackedLayout;
    }

    return (
        <div
            className={`${settings.section.reveal_animation_class} relative`}
            style={{
                paddingTop: `${settings.section.padding_top}px`,
                paddingBottom: `${settings.section.padding_bottom}px`,
            }}
        >
            <div className="relative w-full h-full justify-end items-end">
                <Layout blocks={sortedBlocks} settings={settings} />
            </div>
        </div>
    );
};

